import GET_SOCIALS_AI_INSTRUCTION_BY_ID from "./getSocialsAiInstructionById"
import GET_SOCIALS_AI_INSTRUCTIONS from "./getSocialsAiInstructions"
import GET_SOCIALS_HANDLES_WAVE from "./getSocialsHandlesWave"
import GET_SOCIALS_PLATFORMS from "./getSocialsPlatforms"
import GET_SOCIALS_PROSPECT_DEFAULTS from "./getSocialsProspectDefaults"

export default {
  GET_SOCIALS_AI_INSTRUCTIONS,
  GET_SOCIALS_AI_INSTRUCTION_BY_ID,
  GET_SOCIALS_HANDLES_WAVE,
  GET_SOCIALS_PLATFORMS,
  GET_SOCIALS_PROSPECT_DEFAULTS
}
